import React from 'react';
import FirmField from './FirmField';
import useFirmPatch from './useFirmPatch';

export default function FirmNotesWidget({ firm, firmId, onRefresh }) {
    const { local, patch } = useFirmPatch(firm, firmId, onRefresh);
    return (
        <FirmField
            label=""
            value={local.notes}
            multiline
            placeholder="Add notes…"
            onSave={(v) => patch({ notes: v })}
        />
    );
}
